<template>
  <div class="device column-me">
    <div class="card-div column-me flex1">
      <div class="row-me row-center">
        <div class="width180">
          <el-input placeholder="设备名称" style="width: 100%;" clearable v-model="deviceName"></el-input>
        </div>
        <div class="width180 margin-left10">
          <el-input placeholder="设备编号" style="width: 100%;" clearable v-model="deviceNo"></el-input>
        </div>
        <div class="width130 margin-left10">
          <el-select placeholder="设备类型" style="width: 100%;" filterable clearable v-model="deviceType">
            <el-option v-for="item in deviceTypeArray" :key="item.id" :label="item.name"
                       :value="item.id">
            </el-option>
          </el-select>
        </div>
        <div class="width130 margin-left10">
          <el-select placeholder="品牌" style="width: 100%;" filterable clearable v-model="brand">
            <el-option v-for="item in brandArray" :key="item.id" :label="item.name" :value="item.name">
            </el-option>
          </el-select>
        </div>
        <div class="width130 margin-left10">
          <el-select placeholder="型号" style="width: 100%;" filterable clearable v-model="model">
            <el-option v-for="item in modelArray" :key="item.id" :label="item.name" :value="item.name">
            </el-option>
          </el-select>
        </div>
        <div class="width130 margin-left10">
          <el-select placeholder="启用状态" style="width: 100%;" filterable clearable v-model="enableStatus">
            <el-option v-for="item in enableStatusArray" :key="item.id" :label="item.name"
                       :value="item.id">
            </el-option>
          </el-select>
        </div>
        <div class="width130 margin-left10">
          <el-select placeholder="使用状态" style="width: 100%;" filterable clearable v-model="useState">
            <el-option v-for="item in useStateArray" :key="item.id" :label="item.name"
                       :value="item.id">
            </el-option>
          </el-select>
        </div>
        <div class="btn-blue width100 btn-height40 margin-left10" @click="clickSearch">
          <el-icon>
            <search/>
          </el-icon>
          搜索
        </div>
        <div class="btn-blank width100 btn-height40 margin-left10" @click="clickClear">清空</div>
      </div>
      <div class="row-me row-center margin-top20">
        <div class="btn-blue width120 btn-height40 margin-right10" @click="clickAdd" v-if="canOperate">新增设备</div>
        <div class="btn-blank width100 btn-height40 margin-right10" @click="clickImport" v-if="canOperate">导入</div>
        <div class="btn-blank width130 btn-height40 margin-right10" @click="clickDownCode">下载条形码</div>
        <div class="btn-blank width130 btn-height40 margin-right10" @click="clickPrintCode">打印条形码</div>
      </div>
      <div class="margin-top20">
        <el-table :data="tableData" border header-cell-class-name="table-header-style"
                  cell-class-name="table-cell-style" @selection-change="handleSelectionChange">
          <el-table-column type="selection" width="60" align="center"/>
          <el-table-column prop="name" label="设备名称" align="center" show-overflow-tooltip></el-table-column>
          <el-table-column prop="sn" label="设备编号" align="center" show-overflow-tooltip></el-table-column>
          <el-table-column prop="type" label="设备类型" align="center" show-overflow-tooltip>
            <template #default="scope">
              {{ scope.row.type === 1 ? '煎药机' : scope.row.type === 2 ? '包装机' : '' }}
            </template>
          </el-table-column>
          <el-table-column prop="brandName" label="品牌" align="center" show-overflow-tooltip></el-table-column>
          <el-table-column prop="modelSn" label="型号" align="center" show-overflow-tooltip></el-table-column>
          <el-table-column label="使用状态" align="center" show-overflow-tooltip>
            <template #default="scope">
              {{ scope.row.useStatus === 1 ? '使用中' : scope.row.useStatus === 2 ? '空闲' : '' }}
            </template>
          </el-table-column>
          <el-table-column prop="enableStatus" label="启用状态" align="center" show-overflow-tooltip>
            <template #default="scope">
              {{ scope.row.enableStatus === 1 ? '正常' : scope.row.enableStatus === 2 ? '停用' : '' }}
            </template>
          </el-table-column>
          <el-table-column prop="remark" label="备注" align="center" show-overflow-tooltip></el-table-column>
          <el-table-column prop="createTime" label="创建时间" align="center" show-overflow-tooltip
                           width="220"></el-table-column>
          <el-table-column label="操作" align="center" width="280" v-if="canOperate">
            <template #default="scope">
              <div class="row-me center-all">
                <div class="blue-text" @click="clickPrintCode(scope.row)">打印条形码</div>
                <div class="blue-text margin-left30" v-if="scope.row.enableStatus===2" @click="clickChange(scope.row)">
                  启用
                </div>
                <div class="blue-text margin-left30" v-if="scope.row.enableStatus===1" @click="clickChange(scope.row)">
                  停用
                </div>
                <div class="blue-text margin-left30" @click="clickDelete(scope.row)">删除</div>
              </div>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <div class="margin-top10">
        <el-pagination @current-change="handleCurrentChange" :current-page.sync="pageNo"
                       layout="total, prev, pager, next, jumper" :total="total">
        </el-pagination>
      </div>
    </div>

    <!-- 弹窗 -->
    <el-dialog title="新增设备" v-model="visible" width="600px" top="10vh" :destroy-on-close="true">
      <div class="row-me row-center">
        <div class="left-div"><span class="red-star">*</span>设备名称：</div>
        <div class="flex1">
          <el-input placeholder="请输入" style="width: 100%;" clearable v-model="detailItem.name"
                    maxlength="100"></el-input>
        </div>
      </div>
      <div class="row-me row-center margin-top20">
        <div class="left-div"><span class="red-star">*</span>设备编号：</div>
        <div class="flex1">
          <el-input placeholder="请输入" style="width: 100%;" clearable v-model="detailItem.sn"
                    maxlength="100"></el-input>
        </div>
      </div>
      <div class="row-me row-center margin-top20">
        <div class="left-div"><span class="red-star">*</span>设备类型：</div>
        <div class="flex1">
          <el-select placeholder="请选择" style="width: 100%;" filterable clearable v-model="detailItem.type">
            <el-option v-for="item in deviceTypeArray" :key="item.id" :label="item.name" :value="item.id">
            </el-option>
          </el-select>
        </div>
      </div>
      <div class="row-me row-center margin-top20">
        <div class="left-div"><span class="red-star">*</span>品牌：</div>
        <div class="flex1">
          <el-select placeholder="请选择" style="width: 100%;" filterable clearable v-model="detailItem.brandName">
            <el-option v-for="item in brandArray" :key="item.id" :label="item.name" :value="item.name">
            </el-option>
          </el-select>
        </div>
      </div>
      <div class="row-me row-center margin-top20">
        <div class="left-div"><span class="red-star">*</span>型号：</div>
        <div class="flex1">
          <el-select placeholder="请选择" style="width: 100%;" filterable clearable v-model="detailItem.modelSn">
            <el-option v-for="item in modelArray" :key="item.id" :label="item.name" :value="item.name">
            </el-option>
          </el-select>
        </div>
      </div>
      <div class="row-me row-center margin-top20">
        <div class="left-div"><span class="red-star">*</span>启用状态：</div>
        <div class="flex1">
          <el-select placeholder="请选择" style="width: 100%;" filterable clearable v-model="detailItem.enableStatus">
            <el-option v-for="item in enableStatusArray" :key="item.id" :label="item.name" :value="item.id">
            </el-option>
          </el-select>
        </div>
      </div>
      <div class="row-me margin-top20">
        <div class="left-div">备注：</div>
        <div class="flex1">
          <el-input type="textarea" placeholder="请输入" style="width: 100%;" clearable
                    v-model="detailItem.remark" maxlength="500" show-word-limit autosize></el-input>
        </div>
      </div>
      <div class="row-me row-center flex-end1 margin-top80">
        <div class="btn-blank width110 btn-height40" @click="visible=false">取消</div>
        <div class="btn-blue width110 btn-height40 margin-left20" @click="clickSave">保存</div>
      </div>
    </el-dialog>

    <!-- 导入 -->
    <el-dialog title="导入" v-model="visibleImport" width="40%" top="10vh" :destroy-on-close="true">
      <importExcel name='设备导入模板' :downloadUrl="downloadUrl" :requestUrl="requestUrl"></importExcel>
    </el-dialog>

    <!-- 打印条形码 -->
    <el-drawer v-model="showCodeDrawer" title="打印调配条码" direction="rtl" :destroy-on-close="true">
      <printDeviceCode :objArray="multipleSelection"></printDeviceCode>
    </el-drawer>
  </div>
</template>

<script>
import importExcel from '../../components/import/importExcel.vue'
import printDeviceCode from './printDeviceCode.vue'

export default {
  components: {
    importExcel,
    printDeviceCode,
  },
  data() {
    return {
      deviceName: '',
      deviceNo: '',
      deviceType: '',
      deviceTypeArray: [{id: 1, name: '煎药机'}, {id: 2, name: '包装机'}],
      brand: '',
      brandArray: [],
      model: '',
      modelArray: [],
      enableStatus: '',
      enableStatusArray: [{id: 1, name: '正常'}, {id: 2, name: '停用'}],
      useState: '',
      useStateArray: [{id: 1, name: '使用中'}, {id: 2, name: '空闲'}],
      tableData: [],
      pageNo: 1,
      total: 0,
      multipleSelection: [],
      visible: false,
      detailItem: {},
      visibleImport: false,
      downloadUrl: '', //导入模板下载链接
      requestUrl: '', //导入接口
      showCodeDrawer: false,
      isSelectAll: false,//是否全选
      canOperate: false,
    }
  },
  // 侦听器
  watch: {},
  // 计算属性
  computed: {},
  // html加载完成之前
  created() {
    this.$getMenuOperateAuth(this.$route.path).then(res => {
      this.canOperate = res.data
    })
    this.clickSearch()
    this.getDict()
  },
  // html加载完成后执行。
  mounted() {

  },
  // 事件方法执行
  methods: {
    //搜索
    clickSearch() {
      this.pageNo = 1
      this.getData()
    },
    //清空
    clickClear() {
      this.deviceName = ''
      this.deviceNo = ''
      this.deviceType = ''
      this.brand = ''
      this.model = ''
      this.enableStatus = ''
      this.useState = ''
      this.clickSearch()
    },
    clickAdd() {
      this.detailItem = {
        type: 1,
        enableStatus: 1,
      }
      this.visible = true
    },
    clickImport() {
      this.downloadUrl = this.$axios.defaults.baseURL + '/template/设备导入模板.xlsx'
      this.requestUrl = '/admin/systemConfig/equipmentImport'
      this.visibleImport = true
      this.bus.$off('importSuccess')
      this.bus.$on('importSuccess', res => {
        this.visibleImport = false
        if (res === 'refresh') {
          this.pageNo = 1
          this.getData()
        }
      })
    },
    //下载条形码
    clickDownCode() {
      if (this.multipleSelection.length === 0) {
        this.$message.error('请先选择设备')
        return
      }
      let ids = this.multipleSelection.map(item => {
        return item.id
      })
      let token = sessionStorage.getItem('token')
      let param = {
        ids: ids,
        isSelectAll: this.isSelectAll,
        token: token,
      }
      let url = this.$baseUrl + '/admin/systemConfig/equipmentDownload?' + this.$method.getParamsString(param)
      window.open(url)
    },
    //打印条形码
    clickPrintCode(item) {
      if (this.$method.isEmpty(item.id)) {
        if (this.multipleSelection.length === 0) {
          this.$message.error('请先选择设备')
          return
        }
        this.showCodeDrawer = true
      } else {
        this.multipleSelection = [item]
        this.showCodeDrawer = true
      }
    },
    //启用停用
    clickChange(item) {
      this.$postFormRequest('/admin/systemConfig/equipmentEnableStatus', {
        id: item.id,
        enableStatus: item.enableStatus === 1 ? 2 : 1,
      }).then((res) => {
        if (res) {
          this.$message.success(res.message)
          this.getData()
        }
      }).catch((error) => {
        console.log(error)
      })
    },
    //删除
    clickDelete(item) {
      this.$confirm("确定删除本行数据？", "温馨提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
        this.$postFormRequest('/admin/systemConfig/equipmentDelete', {
          id: item.id,
        }).then((res) => {
          if (res) {
            this.$message.success(res.message)
            this.getData()
          }
        }).catch((error) => {
          console.log(error)
        })
      }).catch(() => {
      });
    },
    handleCurrentChange(pageNo) {
      this.pageNo = pageNo
      this.getData()
    },
    handleSelectionChange(val) {
      this.multipleSelection = val
      this.isSelectAll = this.multipleSelection.length === this.tableData.length
    },
    //保存
    clickSave() {
      if (this.$method.isEmpty(this.detailItem.name)) {
        this.$message.error('请输入设备名称')
        return
      }
      if (this.$method.isEmpty(this.detailItem.sn)) {
        this.$message.error('请输入设备编号')
        return
      }
      if (this.$method.isEmpty(this.detailItem.type)) {
        this.$message.error('请选择设备类型')
        return
      }
      if (this.$method.isEmpty(this.detailItem.brandName)) {
        this.$message.error('请选择设备品牌')
        return
      }
      if (this.$method.isEmpty(this.detailItem.modelSn)) {
        this.$message.error('请选择设备型号')
        return
      }
      if (this.$method.isEmpty(this.detailItem.enableStatus)) {
        this.$message.error('请选择启用状态')
        return
      }
      this.$postRequest('/admin/systemConfig/equipmentUpdate', this.detailItem).then((res) => {
        if (res) {
          this.visible = false
          this.clickSearch()
          this.$message.success(res.message)
        }
      }).catch((error) => {
        console.log(error)
      })
    },
    //获取数据
    getData() {
      this.$postFormRequest('/admin/systemConfig/equipmentPage', {
        name: this.deviceName,
        sn: this.deviceNo,
        type: this.deviceType,
        brandName: this.brand,
        modelSn: this.model,
        enableStatus: this.enableStatus,
        useStatus: this.useState,
        pageNumber: this.pageNo,
      }).then((res) => {
        if (res) {
          this.total = res.data.totalRow
          this.tableData = res.data.list
        }
      }).catch((error) => {
        console.log(error)
      })
    },
    //获取下拉数据
    getDict() {
      this.$getRequest('/admin/systemConfig/getDict', {}).then((res) => {
        if (res) {
          this.brandArray = res.data.pinpaiList
          this.modelArray = res.data.xinghaoList
        }
      }).catch((error) => {
        console.log(error)
      })
    },
  },
}
</script>

<style lang="scss" scoped>
.device {
  height: 100%;

  .card-div {
    margin: 20px;
    background: #FFFFFF;
    box-shadow: 0 0 5px #F3F3F3;
    border-radius: 3px;
    padding: 20px;
    overflow: auto;
  }

  .left-div {
    width: 110px;
    text-align: right;
    margin-right: 10px;
  }
}
</style>
